export default "__VITE_ASSET__D0i43MAo__"